import { ButtonPrimary, ButtonTertiary } from "@nova/component-btn"
import * as Icons from "@nova/component-icons"

export const GenericInspectorPanelConfirmControls = ({
    onCancel,
    onConfirm,
    canConfirm,
}: {
    onCancel: () => void
    onConfirm: () => void
    canConfirm: boolean
}) => {
    return (
        <div className="flex justify-end gap-2">
            <ButtonTertiary title="Cancel" onClick={onCancel} />
            <ButtonPrimary
                title="Confirm"
                RightIcon={Icons.Checkmark}
                disabled={!canConfirm}
                onClick={onConfirm}
            />
        </div>
    )
}
